<template>
  <div class="box" :style="{ width: width + 'px' }">
    <div class="top" v-if="isTitleView == 'extra'">
      <div class="top-wrap">
        <div
          class="top-title"
          :style="{
            width: showExtra ? `calc(100% - ${extraWidth}px)` : '100%',
          }"
        >
          <img :src="imgIcon" alt="" v-if="prefixImg" />
          <div
            class="title"
            :style="{ width: prefixImg ? `calc(100% - 32px)` : '100%' }"
          >
            <slot name="title" />
          </div>
        </div>
        <div
          class="extra"
          :style="{ width: extraWidth + 'px' }"
          v-if="showExtra"
        >
          <slot name="extra" />
        </div>
      </div>
    </div>
    <div class="top-b" v-else>
      <div class="top-wrap">
        <div
          class="top-title"
          :style="{
            width: showExtra ? `calc(100% - ${extraWidth}px)` : '100%',
          }"
        >
          <img :src="imgIcon" alt="" v-if="prefixImg" />
          <div
            class="title"
            :style="{ width: prefixImg ? `calc(100% - 32px)` : '100%' }"
          >
            <slot name="title" />
          </div>
        </div>
        <div
          class="extra"
          :style="{ width: extraWidth + 'px' }"
          v-if="showExtra"
        >
          <slot name="extra" />
        </div>
      </div>
    </div>

    <div class="main">
      <slot name="main" />
    </div>
    <div class="pager">
      <slot name="pager" />
    </div>
  </div>
</template>

<script>
export default {
  name: 'sectionBox',
  components: {},
  props: {
    width: {
      type: Number,
    },
    showExtra: {
      type: Boolean,
    },
    extraWidth: {
      type: Number,
      default: 60,
    },
    prefixImg: {
      type: Boolean,
    },
    imgIcon: {
      // default: require('@/assets/images/home/title-icon.png')
    },
    title: {
      type: String,
    },
    isTitleView: {
      default: 'extra',
    },
  },
  data() {
    return {};
  },
  created() {},
};
</script>

<style lang="less" scoped>
.box {
  width: 100%;
  margin-top: 18px;
  border: 1px solid #eeeeee;
  border-radius: 6px;
  background: #ffffff;
}
.top {
  height: 45px;
  border-bottom: 1px solid #eeeeee;
  padding: 0 20px;
  .top-wrap {
    height: inherit;
    font-size: 16px;
    font-weight: 800;
    color: #333333;
    display: flex;
    align-items: center;
    justify-content: space-between;
    .top-title {
      width: 100%;
      flex-shrink: 0;
      height: inherit;
      display: flex;
      align-items: center;
      > img {
        width: 12px;
        height: 17px;
        margin-right: 12px;
      }
      .title {
        width: 100%;
        height: 100%;
        line-height: 45px;
        text-align: left;
      }
    }
    .extra {
      display: flex;
      align-items: center;
      justify-content: flex-end;
      text-align: right;
      flex-shrink: 0;
      font-weight: 400;
      color: #666;
    }
  }
}
.top-b {
  height: 35px;
  //border-bottom: 1px solid #EEEEEE;
  padding: 0 20px;
  .top-wrap {
    height: inherit;
    font-size: 16px;
    font-weight: 800;
    color: #333333;
    display: flex;
    align-items: center;
    justify-content: space-between;
    .top-title {
      width: 100%;
      flex-shrink: 0;
      height: inherit;
      display: flex;
      align-items: center;
      > img {
        width: 20px;
        height: 22px;
        margin-right: 12px;
      }
      .title {
        width: 100%;
        height: 100%;
        //line-height: 45px;
        text-align: left;
      }
    }
    .extra {
      display: flex;
      align-items: center;
      justify-content: flex-end;
      text-align: right;
      flex-shrink: 0;
      font-weight: 400;
      color: #666;
    }
  }
}
.main {
  min-height: 150px;
  padding: 0 10px;
}
.pager {
}
</style>
